<template>
  <div v-if="location">
    <card class="mb-4" shadow noBody>
      <template v-slot:header>
        <div class="bg-white border-0">
          <div class="row align-items-top">
            <div class="col-8">
              <h3 class="mb-0">Tip Stat Page</h3>
              <div class="text-muted">
                This page allows team members to view the tips for the day at a
                given location. This QR code should be provided to each location
                and it should be displayed in a manner that is only accessible
                to team members.
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="table-responsive">
        <div>
          <table class="table tablesorter">
            <tbody>
              <tr>
                <td class="align-middle">
                  <div>
                    <a
                      href="#"
                      @click.prevent="downloadCode(statUrl)"
                      class="btn btn-sm btn-info"
                      >download QR code</a
                    >
                    <a
                      href="#"
                      @click.prevent="copyUrl(statUrl)"
                      class="btn btn-sm btn-info"
                      >copy url</a
                    >
                    <a
                      href="#"
                      @click.prevent="openUrl(statUrl)"
                      class="btn btn-sm btn-info"
                      >view url</a
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import QRCode from "qrcode";
import copy from "copy-to-clipboard";

export default {
  components: {},
  props: ["location"],
  data() {
    return {};
  },
  computed: {
    statUrl() {
      return `https://${process.env.VUE_APP_TIP_STAT_DOMAIN}/${this.location.locationId}`;
    },
  },
  methods: {
    async downloadCode(url) {
      QRCode.toDataURL(url, { errorCorrectionLevel: "Q" }, (err, url) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = this.location.locationId;
        link.click();
      });
    },
    async copyUrl(url) {
      copy(url);
    },
    async openUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss"></style>
